import { ExistsResponseDto } from '@diritto/common/base/exists-response.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class RecommendEpisodeApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getMyRecommend(id: number): Promise<ExistsResponseDto> {
    const res = await this.http.get<ExistsResponseDto>(`${this.url}/episodes/${id}/recommends`);
    return res.data;
  }

  async recommendEpisode(id: number): Promise<ResponseDto> {
    const res = await this.http.post<undefined, ResponseDto>(`${this.url}/episodes/${id}/recommends`);
    return res.data;
  }

  async cancelRecommendEpisode(id: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/episodes/${id}/recommends`);
    return res.data;
  }
}
